import { Component, Input, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { NodeService } from 'src/app/shared/services/node.services';

@Component({
  selector: 'app-sample-training-offer',
  templateUrl: './sample-training-offer.component.html',
  styleUrls: ['./sample-training-offer.component.scss']
})
export class SampleTrainingOfferComponent implements OnInit {

  @Input() block: any;
  @Input() offerta_formativa_id: any;

  constructor(
    public nodeService: NodeService,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {}

  public retriveLink(link: string): any {
    const linkTemp: string = this.nodeService.retriveLinkTagA(link, 'a').link;
    const isLinkEsternal: boolean = this.nodeService.verifyLinkExternal(linkTemp);
    return {
      isExternal: isLinkEsternal,
      link: linkTemp
    }
  }

}
